import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import AdNumber from "./components/adNumber/AdNumber";
import CashPayment from "./components/cashPayment/CashPayment";
import LimitedAvailability from "./components/limitedAvailability/LimitedAvailability";
import LabelsCA from "./components/labelsCA/LabelsCA";
import LessThanMarket from "./components/lessThanMarket/LessThanMarket";
import PaymentTabBox from "./components/paymentTabBox/PaymentTabBox";
import ShareNP from "./components/shareNP/ShareNP";
import stl from "./LeftColumn.module.css";
import useHelpers from "@hooks/useHelpers";
import { CDN_LINK } from "@globalConfig";
var LeftColumn = function LeftColumn(_ref) {
  var _details$details_card, _details$details_card2, _details$details_card3, _price$vat_price;
  var postData = _ref.postData,
    mostPopular = _ref.mostPopular,
    ShowStory = _ref.ShowStory,
    setPaymentTypeFlag = _ref.setPaymentTypeFlag,
    titleForPaymentBox = _ref.titleForPaymentBox,
    isUsed = _ref.isUsed,
    isTrackingView = _ref.isTrackingView,
    isCancelled = _ref.isCancelled,
    g4_data = _ref.g4_data;
  var _useTranslation = useTranslation(["web_post_view", "web_common"]),
    t = _useTranslation.t;
  var details = postData.details,
    price = postData.price,
    analytics = postData.analytics,
    footer = postData.footer;
  var _useHelpers = useHelpers(),
    createUrlAbsolute = _useHelpers.createUrlAbsolute,
    navigateTo = _useHelpers.navigateTo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.container
  }, /*#__PURE__*/React.createElement("div", {
    className: "m-hide"
  }, /*#__PURE__*/React.createElement("h1", {
    className: stl.carName
  }, details === null || details === void 0 ? void 0 : details.h1), !isTrackingView && (details === null || details === void 0 ? void 0 : details.low_mileage_text) && /*#__PURE__*/React.createElement(LessThanMarket, {
    lowMileage: details === null || details === void 0 ? void 0 : details.low_mileage_text
  }), !isTrackingView && /*#__PURE__*/React.createElement(LabelsCA, {
    tags: details === null || details === void 0 ? void 0 : details.tags
  }), !!(details !== null && details !== void 0 && details.is_preowned) && /*#__PURE__*/React.createElement("p", {
    className: stl.preowned
  }, /*#__PURE__*/React.createElement("img", {
    width: "16px",
    height: "16px",
    src: CDN_LINK + "/assets/images/gray-info-icon.svg" // Ensure this path is correct
    ,
    alt: "info"
  }), /*#__PURE__*/React.createElement("span", null, t("هذه سيارة جديدة تم إصدار لوحاتها مسبقا", {
    ns: "web_post_view"
  }))), mostPopular && isTrackingView && /*#__PURE__*/React.createElement("hr", {
    style: {
      border: "none",
      borderTop: "solid 1px #d8d8d8"
    }
  }), !isTrackingView && /*#__PURE__*/React.createElement(React.Fragment, null, details !== null && details !== void 0 && details.limited_quantity && details !== null && details !== void 0 && (_details$details_card = details.details_card) !== null && _details$details_card !== void 0 && (_details$details_card2 = _details$details_card.is_new) !== null && _details$details_card2 !== void 0 && _details$details_card2.id ? /*#__PURE__*/React.createElement(LimitedAvailability, {
    priceSection: price,
    postId: details === null || details === void 0 ? void 0 : details.id,
    ShowStory: ShowStory,
    post: details,
    footer_section: footer,
    g4_data: g4_data,
    desktop: true,
    have_finance: details === null || details === void 0 ? void 0 : details.have_finance
  }) : details !== null && details !== void 0 && details.have_finance ? /*#__PURE__*/React.createElement(PaymentTabBox, {
    isUsed: isUsed,
    post: details,
    priceSection: price,
    postId: details === null || details === void 0 ? void 0 : details.id,
    postTitle: details === null || details === void 0 ? void 0 : details.title,
    analytic: analytics,
    arboun: footer === null || footer === void 0 ? void 0 : footer.arboun,
    reserved: footer === null || footer === void 0 ? void 0 : footer.reserved,
    ShowStory: ShowStory,
    setPaymentTypeFlag: setPaymentTypeFlag,
    titleForPaymentBox: titleForPaymentBox,
    desktop: true,
    g4_data: g4_data,
    footer_section: footer,
    car_condition: !(details !== null && details !== void 0 && (_details$details_card3 = details.details_card) !== null && _details$details_card3 !== void 0 && _details$details_card3.is_new.id) ? "used" : details !== null && details !== void 0 && details.is_chinese ? "chinese" : "new",
    details: details,
    gallery: postData === null || postData === void 0 ? void 0 : postData.gallery
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CashPayment, {
    priceSection: price,
    postId: details === null || details === void 0 ? void 0 : details.id,
    ShowStory: ShowStory,
    arboun: footer === null || footer === void 0 ? void 0 : footer.arboun,
    postTitle: details === null || details === void 0 ? void 0 : details.title,
    reserved: footer === null || footer === void 0 ? void 0 : footer.reserved,
    g4_data: g4_data,
    footer_section: footer,
    details: details,
    gallery: postData === null || postData === void 0 ? void 0 : postData.gallery
  }))), isTrackingView && /*#__PURE__*/React.createElement("div", {
    className: stl.trackingPrice
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("سعر الكاش", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      color: !isCancelled || (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? "" : "#00B64E"
    }
  }, footer !== null && footer !== void 0 && footer.total_price ? footer === null || footer === void 0 ? void 0 : footer.total_price : price === null || price === void 0 ? void 0 : (_price$vat_price = price.vat_price) === null || _price$vat_price === void 0 ? void 0 : _price$vat_price.text, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_post_view"
  })))), isCancelled ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.isCancelled
  }, " ", t("تم إلغاء الطلب", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) <= 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: stl.fullypaid
  }, " ", t("مدفوع كاملاً", {
    ns: "web_post_view"
  }))) : (footer === null || footer === void 0 ? void 0 : footer.remaining_price) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, t("المبلغ المتبقي", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("span", null, footer === null || footer === void 0 ? void 0 : footer.remaining_price, /*#__PURE__*/React.createElement("span", null, t("ريال", {
    ns: "web_post_view"
  }))))), !isTrackingView && /*#__PURE__*/React.createElement(ShareNP, {
    title: details === null || details === void 0 ? void 0 : details.title,
    postDynamicLink: createUrlAbsolute("/cardetail/".concat(details === null || details === void 0 ? void 0 : details.id)),
    postData: postData
  }), /*#__PURE__*/React.createElement(AdNumber, {
    adNumber: details === null || details === void 0 ? void 0 : details.id,
    isTrackingView: isTrackingView
  }))));
};
export default LeftColumn;